import React, { useEffect } from 'react';
import { Spinner } from '@blueprintjs/core';
import '../../assets/style/loader.scss';

const Loader = () => (
  <div className='global-loader'>
    <Spinner size={100} scale={100} />
  </div>
);

export default Loader;
